// @flow
import * as React from "react"
import "./styles.scss"
import {
    Card,
    Heading,
    TextField,
    Button,
    Tooltip,
    Stack,
    RadioButton,
    Layout,
    Icon,
    TextStyle,
    Checkbox,
} from "@shopify/polaris"
import { ExportMinor, ImportMinor, StarFilledMinor } from "@shopify/polaris-icons"
const ColorPicker = require("rc-color-picker")
import IconList from "../IconList"
import { iconsSet } from "../AppCont/icons_set"
import { connect } from "react-redux"
import Preloader from "../Preloader"
import { bindActionCreators } from "redux"
import Actions from "./../../actions"
import axios from "../../funcs/axios"
type Props = {
    previewCode: String,
    settings: Object,
    app_settings: Object,
    changeGeneralSettings: (a: Object) => void,
    updateIcon: (setting_type: String, icon_type: String, updateObj: Object) => void,
}

type State = {
    app_settings: Object,
    appWaiting: Boolean,
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class GeneralSettings extends React.Component<Props, State> {
    state = {
        app_settings: JSON.parse(JSON.stringify(this.props.app_settings)),
        appWaiting: false,
    }

    static getDerivedStateFromProps(props, state) {
        const { settings } = props
        const visual = $(".preloader-icon-color").prev()
        visual.find("svg").css("fill", settings.preloader_color)
        return null
    }

    appScriptChange(val) {
        const { changeGeneralSettings } = this.props
        changeGeneralSettings({ app_script: val === "script" ? true : false })
    }

    appProxyChange(val) {
        const { changeGeneralSettings } = this.props
        changeGeneralSettings({ app_wishlist_layout: val })
    }

    appChangeColor(val, type) {
        const { changeGeneralSettings } = this.props
        switch (type) {
            case "background":
                changeGeneralSettings({ background_color: val })
                break
            case "text":
                changeGeneralSettings({ text_color: val })
                break
            case "border":
                changeGeneralSettings({ border_color: val })
                break
            default:
                break
        }
    }

    // Export
    exportToJsonFile(jsonData) {
        let dataStr = JSON.stringify(jsonData)
        let dataUri = "data:application/json;charset=utf-8," + encodeURIComponent(dataStr)

        let exportFileDefaultName = "data.json"

        let linkElement = document.createElement("a")
        linkElement.setAttribute("href", dataUri)
        linkElement.setAttribute("download", exportFileDefaultName)
        linkElement.click()
    }
    /**
     * Save Settings Func
     */
    saveSettingsCustome(data, checkImport) {
        const { actions } = this.props
        // Set loading and disable save button
        this.setState({
            appWaiting: true,
        })
        if (checkImport) {
            this.setState({ settingLoading: true })
        }
        this.setState({ app_settings: JSON.parse(JSON.stringify(data)) })
        setTimeout(() => {
            axios
                .post(`${window.SHOPIFY_APP_HOST}/admin/save-app-settings`, this.state.app_settings)
                .then((response) => {
                    const resObj = response.data
                    if (resObj.status === "success") {
                    } else {
                        throw new Error(resObj.msg)
                    }

                    axios
                        .post(
                            `${window.SHOPIFY_APP_HOST}/admin/save-app-text-settings`,
                            this.state.app_settings.general_settings,
                        )
                        .then((response) => {
                            const resObj = response.data
                            if (resObj.status === "success") {
                                actions.AppNotify({
                                    content: resObj.msg,
                                    show: true,
                                    error: false,
                                })
                            } else {
                                throw new Error(resObj.msg)
                            }
                        })
                        .catch((err) => {
                            actions.AppNotify({
                                content: `${err.message}. Please try again.`,
                                show: true,
                                error: true,
                            })
                        })
                        .finally(() => {
                            window.location.reload()
                        })
                })
                .catch((err) => {
                    actions.AppNotify({
                        content: `${err.message}. Please try again.`,
                        show: true,
                        error: true,
                    })
                })
        }, 0)
    }

    //Import
    loadImport(contents) {
        try {
            let setting = JSON.parse(contents)
            this.saveSettingsCustome(setting, true)
        } catch (error) {
            console.log(error)
            this.props.actions.AppNotify({
                content: `${error.message}. Please try again.`,
                show: true,
                error: true,
            })
        }
    }
    openFileDialog(accept, multy = false, callback) {
        var inputElement = document.createElement("input")
        inputElement.type = "file"
        inputElement.accept = accept // Note Edge does not support this attribute
        if (multy) {
            inputElement.multiple = multy
        }
        if (typeof callback === "function") {
            inputElement.addEventListener("change", callback)
        }
        // const inputElement = document.getElementById('file-upload');
        inputElement.dispatchEvent(new MouseEvent("click"))
    }

    // userButton click event
    openDialogClick() {
        // open file dialog for text files
        this.openFileDialog(".json", true, this.fileDialogChanged.bind(this))
    }

    importToJsonFile() {
        // open a dialog function
        this.openDialogClick()
    }

    // file dialog onchange event handler
    fileDialogChanged2(e) {
        var file = e.target.files[0]
        if (!file) {
            return
        }
        let fd = new FormData()
        fd.append("files", file)
        axios({
            method: "post",
            url: `${window.SHOPIFY_APP_HOST}/admin/convert`,
            data: fd,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((response) => {
                const resObj = response.data
                if (resObj.status === "success") {
                    // this.props.actions.AppNotify({
                    //     content: "Re-install successfully",
                    //     show: true,
                    //     error: false,
                    // })
                    // setTimeout(() => {
                    //     window.location.reload()
                    // }, 0)
                } else {
                    throw new Error(resObj.msg)
                }
            })
            .catch((err) => {
                // actions.AppNotify({
                //     content: `Re-install fail. Please try again.`,
                //     show: true,
                //     error: true,
                // })
            })
            .finally(() => {
                this.setState({
                    appWaiting: false,
                })
            })
    }

    convertToJsonFile() {
        // open a dialog function
        this.openFileDialog(".csv", true, this.fileDialogChanged2.bind(this))
    }

    // file dialog onchange event handler
    fileDialogChanged(e) {
        var file = e.target.files[0]
        if (!file) {
            return
        }
        var reader = new FileReader()
        var contents = ""
        reader.onload = (e) => {
            contents = e.target.result
            this.loadImport(contents)
        }
        reader.readAsText(file)
    }

    render() {
        const { settings, changeGeneralSettings } = this.props
        const { appWaiting } = this.state
        return (
            <div className="general-settings">
                {appWaiting ? <Preloader /> : null}
                {/* <Layout>
                    <Layout.Section secondary>
                        <Button onClick={() => this.exportToJsonFile(app_settings)}>
                            <Icon source={ExportMinor} />
                            <span>Export</span>
                        </Button>
                        <Button onClick={() => this.importToJsonFile()}>
                            <Icon source={ImportMinor} />
                            <span>Import</span>
                        </Button> */}
                {/* <Button onClick={() => this.convertToJsonFile()}>
                    <Icon source={ImportMinor} />
                    <span>Convert</span>
                </Button> */}

                {/* <div style={{ marginBottom: "50px" }} className="import-export--desc">
                            You can use above buttons to save/load your current settings.
                        </div>
                    </Layout.Section>
                </Layout> */}
                {/** Enable number status */}
                <div className="standard">
                    <div className="standard-left">
                        <Stack vertical className="standard-left">
                            <TextStyle variation="strong">Standard</TextStyle>
                            <TextStyle variation="subdued">
                              Standard settings are used to manage some of the options that are available for Wishlist / Comapre Feature
                            </TextStyle>
                        </Stack>
                    </div>
                    <div className="standard-right">
                        <Stack vertical>
                            <Card>
                                <Card.Section>
                                    <Checkbox
                                        onChange={() => {
                                            changeGeneralSettings({
                                                unlogged_user: !settings.unlogged_user,
                                            })
                                        }}
                                        checked={!settings.unlogged_user ? false : true}
                                        label="Allow customers who don't log in to add items to their wishlist"
                                        helpText="It will use cookie browsers to store wishlist items"
                                    />
                                </Card.Section>
                                <Card.Section>
                                    <Checkbox
                                        onChange={() => {
                                            changeGeneralSettings({
                                                show_number_status: !settings.show_number_status,
                                            })
                                        }}
                                        checked={!settings.show_number_status ? false : true}
                                        label="Show the number of items in the list"
                                        helpText="This option shows the number of wishlist / compare items added"
                                    />
                                </Card.Section>
                                <Card.Section>
                                    <Checkbox
                                        onChange={() => {
                                            changeGeneralSettings({
                                                app_script: !settings.app_script,
                                            })
                                        }}
                                        checked={settings.app_script ? false : true}
                                        label="Insert JS file to Theme Assets instead of Script Tags"
                                        helpText="This supports better performance by reducing 3rd party scripts"
                                    />
                                </Card.Section>
                                {/* <Card.Section>
                                    <Checkbox
                                        onChange={() => {
                                            changeGeneralSettings({
                                                app_selector: !settings.app_selector,
                                            })
                                        }}
                                        checked={settings.app_selector ? true : false}
                                        label="Using page selector"
                                        helpText="Using page selector"
                                    />
                                </Card.Section> */}
                            </Card>
                            <Card sectioned>
                                <Heading>Preloader icon</Heading>
                                {/** Predefined Icons for preloader -- Add */}
                                <IconList
                                    general={true}
                                    iconList={iconsSet.preloader}
                                    setting={settings.preloader_icon}
                                    iconKey="arn_icon-preloader"
                                    settingType="general_settings"
                                    iconType="preloader_icon"
                                    updateIcon={this.props.updateIcon.bind(this)}
                                />
                            </Card>
                        </Stack>
                    </div>
                </div>
                <Stack distribution="equalSpacing"></Stack>
            </div>
        )
    }
}
export default connect(null, mapDispatchToProps)(GeneralSettings)
